<div class="powered-by-stripe-container" [class.dark]="darkTheme">
  <mat-icon class="lock-icon">lock</mat-icon>
  <div>
    <!-- TODO (GB-7600): add to shared translations once implemented -->
    <span translate="Secure payments powered by"></span>
    <gb-stripe-icon [darkTheme]="darkTheme"></gb-stripe-icon>
  </div>
</div>
